export default __webpack_public_path__ + "static/media/welcome.6ab0cff9.wav";